import { render, staticRenderFns } from "./ComplianceDataQualityDashboard.vue?vue&type=template&id=d9592062&scoped=true"
import script from "./ComplianceDataQualityDashboard.vue?vue&type=script&lang=js"
export * from "./ComplianceDataQualityDashboard.vue?vue&type=script&lang=js"
import style0 from "./ComplianceDataQualityDashboard.vue?vue&type=style&index=0&id=d9592062&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9592062",
  null
  
)

export default component.exports